import { combineReducers } from "redux";
import auth from "../views/Sign-in/reducer";

const rootReducer = combineReducers({
    auth
});
export default rootReducer;
